import { render } from "./TermsOfServicePage.vue?vue&type=template&id=2001ecab&scoped=true"
import script from "./TermsOfServicePage.vue?vue&type=script&lang=js"
export * from "./TermsOfServicePage.vue?vue&type=script&lang=js"

import "./TermsOfServicePage.vue?vue&type=style&index=0&id=2001ecab&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2001ecab"]])

export default __exports__